import {createClass} from 'react'

export let StringNotEmptyRegex = /[^\s\\]/


